import { ThemeSetting } from '@magnetar/data-access/prisma/client'

export interface ThemeSettingResponse {
  success: boolean
  data: ThemeSetting | null
  error?: {
    code: string
    message: string
  }
}

export type UpdateThemeSettingRequest = Omit<
  ThemeSetting,
  'theme_id' | 'created_at' | 'examination_room_id'
>

export interface ThemeSettingErrorResponse {
  success: boolean
  data: null
  error: {
    code: string
    message: string
  }
}

// Must stay in sync with createDefaultThemeSetting() in
// packages/data-access/src/repositories/themeSettingRepository.ts — that's what a
// broadcast device actually gets on first use, so "reset to default" should match it.
// Kept as a literal here (not imported) to avoid a circular package dependency, since
// this package already depends on @magnetar/data-access for the ThemeSetting type.
export const DEFAULT_THEME_COLORS = {
  header_bg_color: '#80CBC4',
  header_text_color: '#000000',
  body_bg_color: '#B2DFDB',
  list_bg_color: '#FFFFFF',
  list_odd_header_color: '#E3F2FD',
  list_even_header_color: '#E8F5E9',
  list_odd_color: '#EEF7FD',
  list_even_color: '#F1F9F1',
  list_now_text_color: '#2196F3',
  list_next_text_color: '#4CAF50',
  list_text_color: '#000000',
  video_button_color: '#80CBC4',
  clinic_info_bg_color: '#FFFFFF',
} as const
